module.exports = {
    BASE_URL: BASE_URL,
    auth: BASE_URL + "auth/",
    authCaptcha: BASE_URL + "auth/captcha/",
    // El backend devuelve la imagen del captcha como path absoluto del sitio
    // ('/captcha/image/<key>/') y BASE_URL termina en '/', asi que hay que
    // sacar uno de los dos para no armar una URL con '//'.
    captchaImagen: function (path) {
        return path ? BASE_URL.replace(/\/$/, '') + path : null;
    },
    clearToken: BASE_URL + "auth/clear-token/",
    authCheck: BASE_URL + "auth/check/",
    authCheckWithToken: BASE_URL + "auth/check-with-token/",
    authLogout: BASE_URL + "auth/logout/",
    authGetPermissions: BASE_URL + "auth/permissions/",
    // Segundo paso del login de los usuarios que tienen autenticador. No lleva
    // token: el token es justamente lo que este endpoint devuelve.
    authSegundoFactor: BASE_URL + "auth/2fa/",
    usuarios: {
        perfil: BASE_URL + "usuarios/perfil/",
        // La pestaña Sesiones del modal de Perfil. El DELETE de una sesion va a
        // esta misma URL con el id y una barra atras.
        perfilSesiones: BASE_URL + "usuarios/perfil/sesiones/",
        // La pestaña Autenticador del modal de Perfil. El GET de la primera
        // trae el estado y su POST arranca el registro; las otras dos lo
        // confirman y lo quitan. Las tres son POST y no DELETE porque el cuerpo
        // lleva la contraseña o el codigo.
        //
        // Las tres existen igual que en el frontend-admin porque Perfil.js es
        // el mismo archivo en los dos proyectos y tiene que poder copiarse tal
        // cual. La revocacion administrativa, en cambio, esta solo alla: aca el
        // ABM de usuarios no tiene pantalla.
        perfilAutenticador: BASE_URL + "usuarios/perfil/autenticador/",
        perfilAutenticadorConfirmar: BASE_URL + "usuarios/perfil/autenticador/confirmar/",
        perfilAutenticadorQuitar: BASE_URL + "usuarios/perfil/autenticador/quitar/",
        usuarios: BASE_URL + "usuarios/usuarios/",
        permisos: BASE_URL + "usuarios/permisos/",
        grupos: BASE_URL + "usuarios/grupos/",
    },
    personas:{
        areasselect:BASE_URL + "personas/areas/select/",
        personas:BASE_URL + "personas/personas/",
        personasSelect:BASE_URL +  "personas/personas/select/", // No se usa
        // El id va en el medio del path, por eso es funcion y no un prefijo.
        personasSelectMenuDiario: (menuDiarioId) => BASE_URL + "personas/viandas/menu-diario/" + menuDiarioId + "/select/",
        datosPersonasUsuarios: BASE_URL + "personas/personas/datosusuario/",
    },
    comedor:{
        // Buscador de comedores (el input "Planta"). El ABM comedor/comedor/ es
        // del admin y pide permisos admin_*.
        comedorSelect: BASE_URL + "comedor/comedor/select/",
        ultimoCodigo: BASE_URL + "comedor/comedor/ultimoCodigo/", // No se usa
    },
    dependencias:{
        cuentas:BASE_URL + "dependencias/cuentas/",
        tiposdependencias:BASE_URL + "dependencias/tipos/",
        tiposultimocodigo:BASE_URL + "dependencias/tipos/ultimocodigo/", // No se usa
        dependenciasselect: BASE_URL + "dependencias/dependencias/select/",
        plantas:BASE_URL + "dependencias/plantas/",
        plantasUC:BASE_URL + "dependencias/plantas/ultimocodigo/", // No se usa
        plantasselect:BASE_URL + "dependencias/plantas/select/",
    },
    pedidos:{
        // Pedidos del usuario logueado, uno por categoria. El backend resuelve el
        // responsable y el tipo_pedido con el usuario del request y la ruta.
        misInsumos: BASE_URL + "pedidos/mis/insumos/",
        misCafeteria: BASE_URL + "pedidos/mis/cafeteria/",
        misRefrigerios: BASE_URL + "pedidos/mis/refrigerios/",
        cambioestado: BASE_URL + "pedidos/cambioestado/"
    },
    productos:{
        rubros:BASE_URL + "productos/rubros/",
        rubroultimocodigo:BASE_URL + "productos/rubros/ultimocodigo/", // No se usa
        // Selects de producto por categoria de pedido. El backend fija la
        // categoria en el endpoint, no viaja como filtro.
        insumosSelect: BASE_URL + "productos/insumos/select/",
        cafeteriaSelect: BASE_URL + "productos/cafeteria/select/",
        refrigeriosSelect: BASE_URL + "productos/refrigerios/select/",
        historialstock: BASE_URL + "productos/historialstock/"
    },
    compviandas:{
        complementos:BASE_URL + "comviandas/complementos/",
        complementosUC: BASE_URL + "comviandas/complementos/ultimoCodigo/", // No se usa

        bebidas:BASE_URL + "comviandas/bebidas/",
        bebidasUC: BASE_URL + "comviandas/bebidas/ultimoCodigo/", // No se usa

        ensaladas:BASE_URL + "comviandas/ensaladas/",
        ensaladasUC: BASE_URL + "comviandas/ensaladas/ultimoCodigo/", // No se usa

        menuppal:BASE_URL + "comviandas/menuppal/",
        menuppalUC: BASE_URL + "comviandas/menuppal/ultimoCodigo/", // No se usa

        postres:BASE_URL + "comviandas/postres/",
        postresUC: BASE_URL + "comviandas/postres/ultimoCodigo/", // No se usa
    },
    configuracion:{
        configuracionGral: BASE_URL + "configuracion/configuraciongral/",
        getconfig: BASE_URL + "configuracion/configuraciongral/getconfig/",
   },
    viandas:{
        menudiario: BASE_URL + "viandas/menudiario/",
        menudiarioHoy: BASE_URL + "viandas/menudiario/hoy/",
        // Pedidos de vianda del usuario logueado. El backend registra como
        // responsable a la persona del usuario del request, no se manda.
        misPedidos: BASE_URL + "viandas/mis/pedidos/",
        misPedidosDetalles: BASE_URL + "viandas/mis/pedidos/detalles/",
        // No va en mis/: el alcance lo da el codigo de verificacion, no el
        // usuario. Sirve para cualquier pedido de vianda del que se tenga el codigo.
        adjuntable: BASE_URL + "viandas/pedidos/adjuntable/codigo-verificacion/",
    },
    container: BASE_URL + "container/",
}



// WEBPACK FOOTER //
// ./src/api/api.js